import { useReducer, useCallback } from "react";
import { http } from "../utils/http";

const initialState = {
  regionsDropDown: [],
  manufacturersDropDown: [],
  statusTypesDropDown: [],
  alarmCategoriesTypesDropDown: [],
  PremiseTypesDropDown: [],
  roleTypesDropDown: [],
  deviceTypesDropDown: [],
  alarmTypesDropDown: [],
  billingTypesDropDown: [],
  intervalTypesDropDown: [],
  techniciansDropdown:[],
  technicianGroupsDropdown:[],
  caseStatusDropdown: [],
  devices:[],
  caseTypes:[],
  isLoading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_REGIONS_DROPDOWN":
      return { ...state, regionsDropDown: action.payload };
    case "SET_MANUFACTURER_DROPDOWN":
      return { ...state, manufacturersDropDown: action.payload };
    case "SET_STATUS_TYPE_DROPDOWN":
      return { ...state, statusTypesDropDown: action.payload };
    case "SET_ALARM_CATEGORIES_DROPDOWN":
      return { ...state, alarmCategoriesTypesDropDown: action.payload };
    case "SET_PREMISE_TYPE_DROPDOWN":
      return { ...state, PremiseTypesDropDown: action.payload };
    case "SET_ROLE_TYPE_DROPDOWN":
      return { ...state, roleTypesDropDown: action.payload };
    case "SET_DEVICE_TYPE_DROPDOWN":
      return { ...state, deviceTypesDropDown: action.payload };
    case "SET_ALARM_TYPE_DROPDOWN":
      return { ...state, alarmTypesDropDown: action.payload };
    case "SET_Billing_Totaliser_TYPE_DROPDOWN":
      return { ...state, billingTypesDropDown: action.payload };
    case "SET_INTERVAL_DROPDOWN":
      return { ...state, intervalTypesDropDown: action.payload };
    case "SET_TECHNICIAN_GROUPS_DROPDOWN":
      return {...state , technicianGroupsDropdown:action.payload};
    case "SET_TECHNICIAN_DROPDOWN":
      return {...state , techniciansDropdown:action.payload};
    case "SET_CASE_STATUS_DROPDOWN":
      return {...state, caseStatusDropdown:action.payload };
    case "SET_DEVICES_DROPDOWN" :
      return {...state, devices: action.payload };
    case "SET_CASE_TYPES_DROPDOWN":
      return { ...state, caseTypes: action.payload };
    case "SET_LOADING":
      return { ...state, isLoading: action.payload };
    default:
      return state;
  }
};

export function useDropdowns() {
  const [state, dispatch] = useReducer(reducer, initialState);

  const memoizedDispatch = useCallback(dispatch, [dispatch]);

  const memoizedActions = {
    getIntervalDropDown: useCallback(async () => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get("/Dropdowns/get-interval-types");
        const DropDown = response?.data;
        memoizedDispatch({ type: "SET_INTERVAL_DROPDOWN", payload: DropDown });
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),
    getRegionsDropDown: useCallback(async () => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get("/Dropdowns/get-regions");
        const DropDown = response?.data;
        memoizedDispatch({ type: "SET_REGIONS_DROPDOWN", payload: DropDown });
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),

    getManufacturersDropDown: useCallback(async () => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get("/Dropdowns/get-menufacturers");
        const DropDown = response?.data;
        memoizedDispatch({
          type: "SET_MANUFACTURER_DROPDOWN",
          payload: DropDown,
        });
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),

    getStatusTypesDropDown: useCallback(async () => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get("/Dropdowns/get-status-types");
        const DropDown = response?.data;
        memoizedDispatch({
          type: "SET_STATUS_TYPE_DROPDOWN",
          payload: DropDown,
        });
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),

    getAlarmCategoriesListDropDown: useCallback(
      async (id) => {
        memoizedDispatch({ type: "SET_LOADING", payload: true });
        try {
          if (id) {
            const response = await http.get(
              "/Dropdowns/get-alarm-categories-types?devicetypeId=" + id
            );
            const DropDown = response?.data;
            memoizedDispatch({
              type: "SET_ALARM_CATEGORIES_DROPDOWN",
              payload: DropDown,
            });
          } else {
            memoizedDispatch({
              type: "SET_ALARM_CATEGORIES_DROPDOWN",
              payload: [],
            });
          }
        } finally {
          memoizedDispatch({ type: "SET_LOADING", payload: false });
        }
      },
      [memoizedDispatch]
    ),

    getPremiseTypesDropDown: useCallback(async () => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get("/Dropdowns/get-premise-types");
        const DropDown = response?.data;
        memoizedDispatch({
          type: "SET_PREMISE_TYPE_DROPDOWN",
          payload: DropDown,
        });
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),

    getRoleTypesDropDown: useCallback(async () => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get("/Dropdowns/get-role-types");
        const DropDown = response?.data;
        memoizedDispatch({ type: "SET_ROLE_TYPE_DROPDOWN", payload: DropDown });
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),

    getDeviceTypesDropDown: useCallback(async () => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get("/Dropdowns/get-device-types");
        const DropDown = response?.data;
        memoizedDispatch({
          type: "SET_DEVICE_TYPE_DROPDOWN",
          payload: DropDown,
        });
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),

    getAlarmTypesDropDown: useCallback(async () => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get("/Dropdowns/get-alarm-types");
        const DropDown = response?.data;
        memoizedDispatch({
          type: "SET_ALARM_TYPE_DROPDOWN",
          payload: DropDown,
        });
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),

    getBillingTotaliserTypesDropDown: useCallback(async () => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get(
          "/Dropdowns/get-billing-totaliser-types"
        );
        const DropDown = response?.data;
        memoizedDispatch({
          type: "SET_Billing_Totaliser_TYPE_DROPDOWN",
          payload: DropDown,
        });
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),

    getTechnicianGroupsDropdown: useCallback(async (regionData) => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get(
            "/Dropdowns/technician-groups",
            {params: regionData}
        );
        const DropDown = response?.data;
        memoizedDispatch({
          type: "SET_TECHNICIAN_GROUPS_DROPDOWN",
          payload: DropDown,
        });
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),

    getTechnicianDropdown: useCallback(async (regionData) => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get(
            "/Dropdowns/technicians",
            {
              params: {
                region: regionData
              }
            }
        );
        const DropDown = response?.data;
        memoizedDispatch({
          type: "SET_TECHNICIAN_DROPDOWN",
          payload: DropDown,
        });
        return response?.data;
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),


    getCaseStatusDropdown: useCallback(async () => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get(
            "/Dropdowns/case-statuses"
        );
        const DropDown = response?.data;
        memoizedDispatch({
          type: "SET_CASE_STATUS_DROPDOWN",
          payload: DropDown,
        });
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),


    getAllDevicesDropdown: useCallback(async (deviceTypeId) => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get(
            "/Dropdowns/devices",
            {params: deviceTypeId}
        );
        const DropDown = response?.data;
        memoizedDispatch({
          type: "SET_DEVICES_DROPDOWN",
          payload: DropDown,
        });
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),

    getAllCaseTypeDropdown: useCallback(async () => {
      memoizedDispatch({ type: "SET_LOADING", payload: true });
      try {
        const response = await http.get(
            "/Dropdowns/case-types"
        );
        const DropDown = response?.data;
        memoizedDispatch({
          type: "SET_CASE_TYPES_DROPDOWN",
          payload: DropDown,
        });
      } finally {
        memoizedDispatch({ type: "SET_LOADING", payload: false });
      }
    }, [memoizedDispatch]),
  };

  return { state, dispatch: memoizedDispatch, ...memoizedActions };
}
